module.exports = __webpack_public_path__ + "img/9.4474088e.png";